export class OfferRuleModel {
  id?: number;
  accountId: number;
  offerSetId?: number;
  year?: number;
  make?: string;
  model?: string;
  trim?: string;
  minSalePrice?: number;
  maxSalePrice?: number;
  vehicleLimit?: number;
  vehicleCondition?: string;
  dollarAmountDiscount?: number;
  isPrivate?: boolean;
  status?: string;
  created?: string;
  modified?: string;
}
